<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" label-width="100px">
            <el-form-item label="借阅目的" prop="purpose">
                <el-select v-model="searchForm.purpose" clearable placeholder="请选择借阅目的">
                    <el-option
                            v-for="item in $dictUtils.getDictList('purpose_type')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="借阅申请时间" prop="applicationTime">
                <el-date-picker
                        v-model="searchForm.applicationTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="借阅状态" prop="applicationState">
                <el-select v-model="searchForm.applicationState" clearable placeholder="请选择借阅状态">
                    <el-option
                            v-for="item in $dictUtils.getDictList('application_state')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关键字" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20" placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                @selection-change="selectionChangeHandle"
                @sort-change="sortChangeHandle"
                size="small" height="100%"
                class="table" ref="multipleTable" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="applicationOdd" label="借阅单号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="purpose" label="借阅目的" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("purpose_type", scope.row.purpose, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="newApplicationContent" label="借阅内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationDate" label="借阅开始时间" sortable
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationDay" label="借阅天数" sortable show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注说明" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationNum" label="借阅数量" sortable show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationState" label="借阅状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("application_state", scope.row.applicationState, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="createByName" label="审核人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" label="审核时间" sortable show-overflow-tooltip></el-table-column>
            <el-table-column prop="returnDate" label="归还时间" sortable show-overflow-tooltip></el-table-column>
            <el-table-column prop="submitTime" label="申请时间" sortable show-overflow-tooltip></el-table-column>
            <el-table-column
                    fixed="right"
                    min-width="250"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:view')" type="text" size="small"
                               @click="view(scope.row, 'view')">详情
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:edit')" type="text" size="small"
                               v-show="scope.row.applicationState == 0 || scope.row.applicationState == 4 || scope.row.applicationState == 5"
                               @click="view(scope.row, 'edit')">编辑
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:submit')" type="text" size="small"
                               v-show="scope.row.applicationState == 0"
                               @click="view(scope.row, 'edit')">提交
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:resubmit')" type="text" size="small"
                               v-show="scope.row.applicationState == 4 || scope.row.applicationState == 5"
                               @click="resubmit(scope.row, 'edit')">重新提交
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:revert')" type="text" size="small"
                               v-show="scope.row.applicationState == 2"
                               @click="revert(scope.row)">归还
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:revoke')" type="text" size="small"
                               v-show="scope.row.applicationState == 1"
                               @click="revoke(scope.row)">撤回
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:record')" type="text" size="small"
                               @click="recordData(scope.row)">审核记录
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:myApplication:delete')" type="text" size="small"
                               v-show="scope.row.applicationState == 0 || scope.row.applicationState == 3 || scope.row.applicationState == 4 || scope.row.applicationState == 5"
                               @click="deleteData(scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-borrowing ref="addBorrowing" @refresh="refreshList(1,1)"></add-borrowing>
        <audit-records ref="auditRecords"></audit-records>
    </div>
</template>

<script>
import AddBorrowing from "@/views/modules/academic/applyFor/addBorrowing.vue";
import AuditRecords from "@/components/toExamine/auditRecords.vue";

export default {
    name: "myApplication",
    components: {AuditRecords, AddBorrowing},
    data() {
        return {
            searchForm: {
                purpose: '',
                applicationTime: [],
                applicationStartDate: '',
                applicationEndDate: '',
                applicationState: '',
                keyword: '',
                current: 1,
                size: 20,
            },
            total: 0,
            borrowingStatusList: [],

            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (this.searchForm.applicationTime && this.searchForm.applicationTime.length != 0) {
                this.searchForm.applicationStartDate = this.searchForm.applicationTime[0]
                this.searchForm.applicationEndDate = this.searchForm.applicationTime[1]
            } else {
                this.searchForm.applicationStartDate = ''
                this.searchForm.applicationEndDate = ''
            }
            let searchData = JSON.parse(JSON.stringify(this.searchForm))
            this.$delete(searchData, 'applicationTime')
            this.loading = true
            this.$axios(this.api.academic.resourceapplicationList, searchData).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    this.dataList.forEach(item => {
                        let applicationList = item.applicationContent.split(',')
                        let newApplicationContent = []
                        applicationList.forEach(item2 => {
                            if (item2 == 0) {
                                newApplicationContent.push('脱敏字段')
                            }
                            if (item2 == 1) {
                                newApplicationContent.push('在线预览')
                            }
                            if (item2 == 2) {
                                newApplicationContent.push('文件下载')
                            }
                        })
                        this.$set(item, 'newApplicationContent', newApplicationContent.join(','))
                    })
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },
        //排序
        sortChangeHandle(obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },
        //详情 typeName view详情 edit编辑
        view(row, typeName) {
            this.$refs.addBorrowing.init(row, typeName)
        },

        //重新提交
        resubmit(row) {
            this.$axios(this.api.academic.resourceapplicationUpdateById, {
                id: row.id,
                applicationState: 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success(`提交成功`)
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //归还
        revert(row) {
            this.$confirm(`归还后，借阅的资源权限将被收回`, '确定归还借阅资源？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.resourceapplicationUpdateById, {
                    id: row.id,
                    applicationState: 3,
                }, 'put').then(data => {
                    if (data && data.status) {
                        this.$message.success(`归还成功`)
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //撤回
        revoke(row) {
            this.$confirm(`撤回后，将取消借阅申请`, '确定撤回？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.resourceapplicationUpdateById, {
                    id: row.id,
                    applicationState: 5,
                    auditId: row.auditId
                }, 'put').then(data => {
                    if (data && data.status) {
                        this.$message.success(`撤回成功`)
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //审核记录
        recordData(row) {
            this.$refs.auditRecords.init(row.id)
        },

        //删除
        deleteData(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.id
            })
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.resourceapplicationRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    },
}
</script>

<style scoped>

</style>
